/** Material UI Icons. */
import DescriptionIcon from '@mui/icons-material/Description';
import ImageIcon from '@mui/icons-material/Image';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import FontDownloadIcon from '@mui/icons-material/FontDownload';
import HttpIcon from '@mui/icons-material/Http';
import TerminalIcon from '@mui/icons-material/Terminal';
import BookIcon from '@mui/icons-material/Book';
import MoreIcon from '@mui/icons-material/More';

export default function DragAndDropFileType(props) {
    /** Get props from DragAndDrop.js */
    const { fileType } = props;

    /** Maps file extensions to their respective categories.  */
    const fileTypeCategoryMap = {
        document: ['csv', 'doc', 'docx', 'pdf', 'rtf', 'txt', 'odt', 'xls', 'xlsx', 'ppt', 'pptx', 'odp', 'ods'],
        image: ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'svg', 'ico', 'webp', 'tif', 'tiff', 'avif'],
        audio: ['aac', 'mp3', 'wav', 'weba', 'ogg', 'oga', 'opus', 'mid', 'midi'],
        video: ['mp4', 'avi', 'mpeg', 'webm', 'ogv', 'ts', '3gp', '3g2'],
        archive: ['zip', 'rar', '7z', 'bz', 'bz2', 'gz', 'tar'],
        font: ['ttf', 'otf', 'woff', 'woff2', 'eot'],
        web: ['html', 'htm', 'css', 'js', 'mjs', 'json', 'jsonld', 'xml', 'xhtml', 'php', 'xul'],
        executable: ['bin', 'exe', 'sh', 'csh', 'jar'],
        ebook: ['azw', 'epub'],
        other: ['arc', 'cda', 'ics', 'vsd', 'mpkg'],
    };

    /** Maps file categories to corresponding Material-UI icons. */
    const categoryIconMap = {
        document: <DescriptionIcon sx={{ fontSize: '32px' }} />,
        image: <ImageIcon sx={{ fontSize: '32px' }} />,
        audio: <AudioFileIcon sx={{ fontSize: '32px' }} />,
        video: <VideoFileIcon sx={{ fontSize: '32px' }} />,
        archive: <FolderZipIcon sx={{ fontSize: '32px' }} />,
        font: <FontDownloadIcon sx={{ fontSize: '32px' }} />,
        web: <HttpIcon sx={{ fontSize: '32px' }} />,
        executable: <TerminalIcon sx={{ fontSize: '32px' }} />,
        ebook: <BookIcon sx={{ fontSize: '32px' }} />,
        other: <MoreIcon sx={{ fontSize: '32px' }} />,
    };

    if (fileType === undefined || fileType === null) return;

    /** Function for finding the right category based on a file extension.. */
    const findCategory = () => {
        for (const [key, values] of Object.entries(fileTypeCategoryMap)) {
            if (values.includes(fileType)) {
                return key;
            }
        }
        return null;
    };

    return categoryIconMap[findCategory()];
}
